import { Job } from '@models/job/job';

export interface SocialMedia {
  label: string;
  icon: string;
  shareUrl: string;
  getShareParams(permalink: string, job?: Job): Record<string, string>;
}

export const socialMedia: SocialMedia[] = [
  // https://developers.facebook.com/docs/sharing/reference/share-dialog
  {
    label: 'Facebook',
    icon: 'facebook',
    shareUrl: 'https://www.facebook.com/sharer/sharer.php',
    getShareParams: (permalink) => ({
      u: permalink,
      mode: 'message',
    }),
  },

  // https://developer.twitter.com/en/docs/twitter-for-websites/web-intents/overview
  {
    label: 'Twitter',
    icon: 'twitter',
    shareUrl: 'https://twitter.com/intent/tweet',
    getShareParams: (permalink, job) => ({
      url: permalink,
      text: `Super job à pourvoir ! ${job.title} chez ${job.company.name} via @Wizbii_FR ${permalink}`,
    }),
  },

  // https://developer.linkedin.com/docs/share-on-linkedin
  {
    label: 'LinkedIn',
    icon: 'linkedin',
    shareUrl: 'https://www.linkedin.com/shareArticle',
    getShareParams: (permalink) => ({
      mini: 'true',
      url: permalink,
    }),
  },

  // https://developers.facebook.com/docs/sharing/messenger/web
  {
    label: 'Messenger',
    icon: 'messenger',
    shareUrl: 'fb-messenger://share',
    getShareParams: (permalink) => ({
      link: permalink,
    }),
  },

  // https://faq.whatsapp.com/en/android/28000012
  {
    label: 'WhatsApp',
    icon: 'whatsapp',
    shareUrl: 'whatsapp://send',
    getShareParams: (permalink, job) => ({
      text: `Super job à pourvoir ! ${job.title} chez ${job.company.name} via @Wizbii_FR ${permalink}`,
    }),
  },
];
